export default __webpack_public_path__ + "static/media/failed.fb0c5ede.svg";